export enum RAGStatus {
  RED = 'red',
  AMBER = 'amber',
  GREEN = 'green',
}
